import Contentstack from 'contentstack';
import type { Entry } from '@/types/contentstack';
import { logError } from '@utils/datadog';

// The `contentstack` browser bundle is UMD; Vite/esbuild expose the SDK as the
// module's default export, so a namespace import would leave `.Stack` undefined.
const stack = Contentstack.Stack({
  api_key: import.meta.env.VITE_CONTENTSTACK_API_KEY,
  delivery_token: import.meta.env.VITE_CONTENTSTACK_DELIVERY_TOKEN,
  environment: import.meta.env.VITE_CONTENTSTACK_ENVIRONMENT,
});

/**
 * Fetches a page entry by its URL slug. Mirrors the legacy Angular
 * `ContentstackService.getEntryByUrl`: queries the `page` content type by the
 * `url` field (prefixed with `/`) and returns the first matching entry.
 */
export async function getEntryByUrl(url: string): Promise<Entry> {
  try {
    const result = await stack
      .ContentType('page')
      .Query()
      .where('url', `/${url}`)
      .toJSON()
      .findOne();
    return result as unknown as Entry;
  } catch (error) {
    logError('contentstack.getEntryByUrl failed', {
      url,
      error: error instanceof Error ? error.message : String(error),
    });
    throw error;
  }
}
